import { Complaint } from '../Complaint'
import { formSchema } from './schema'
import { fugitive } from '../../strings/titles'
import { routePaths as routes } from '../../utilities/routePaths'
import { withBackButtonProtection } from '../../components/withBackButtonProtection'
import { withDocTitle } from '../../components/withDocTitle'
import withRecaptcha from '../withRecaptcha'
import {
  formatPersonData,
  formatAddressData,
  dateToString,
  validateInteger
} from '../../utilities'

export class FugitiveComplaint extends Complaint {
  complaintType = 'fugitive'
  schema = formSchema(this.saveFormData)
  successURL = routes.fugitive.confirmation

  _formatDetailData = data => {
    const {
      age,
      confidence_level,
      height,
      location_address,
      location_date,
      weight,
      ...rest
    } = data
    const address = formatAddressData(location_address)
    const detail = Object.keys(rest).reduce(
      (acc, key) =>
        !['first_name', 'last_name', 'phone', 'email'].includes(key)
          ? { ...acc, [key]: rest[key] }
          : acc,
      {}
    )
    return {
      ...detail,
      ...address,
      age: validateInteger(age),
      confidence_level: validateInteger(confidence_level),
      height: validateInteger(height),
      location_date: dateToString(location_date),
      weight: validateInteger(weight)
    }
  }

  formatComplaintForRequest(formData) {
    const { documents, ...data } = formData
    const complainant = formatPersonData(data)
    const detail = this._formatDetailData(data)

    return Object.freeze({
      analyst_complaint_type: this.complaintType,
      complaint_type: this.complaintType,
      complainant,
      detail,
      documents,
      recaptcha_score: this.props.recaptchaScore,
      source: 'fugitive'
    })
  }
}

export default withRecaptcha(
  withBackButtonProtection(withDocTitle(FugitiveComplaint, fugitive))
)
